// extracted by mini-css-extract-plugin
export default {"header":"styles_header__cj7PH","logoContainer":"styles_logoContainer__SLF3D"};